<script setup lang="ts">
let shadowDOM: ShadowRoot | undefined = undefined;
const container = ref<HTMLElement>();
const contentsElement = document.createElement("div");

onMounted(() => mountShadowDOM());

const html = ref(`<div>
	<style type="text/css">
		/*@font-face {
    font-family: 'Source Sans Pro';
    src: url('fonts/source-sans-pro-v13-latin-regular.woff2') format('woff2'), url('fonts/source-sans-pro-v13-latin-regular.woff') format('woff'), url('fonts/source-sans-pro-v13-latin-700.woff') format('woff'), url('fonts/source-sans-pro-v13-latin-700.woff2') format('woff2');
}*/
		/*@font-face {
    font-family: 'FiraSans';
    src: url('fonts/FiraSans-Regular.otf') format('opentype');
}*/
		/*@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700&display=swap');*/

		/* NOTE:
    This file is the source for the CSS used in styling ChordPro to HTML for both Chord Sheet Editor and SongSelect.
    The source comes from a file located in the AWS S3 bucket:  songselect.ccli.com/CSS.
    A version number is tagged onto the end of the file name, such as:
        - ChordSheet_v21.css

    If you want to test with a local CSS, first make sure this file matches the latest version in the S3 bucket. If not, then update this from the S3 file.
    You then need to modify the web.config ChordSheetCSS key value to the path to this file.
    When you are done making changes, place this file in S3 with a new version number, and modify web.config to point to that new S3 file.
    When adding a file to S3, you must set it to public before the web site can use it.
*/


		.cproSongHeader {
			background-color: #ffffff;
			border: none;
			font-family: Verdana, Arial, Helvetica, sans-serif;
			/*font-family: 'Source Sans Pro';*/
			overflow: visible;
			width: 100%;
		}

		.cproSSLogo {
			float: right;
			/*padding-right: .4em;
    width: 130pt;*/
			width: 25%;
			max-width: 130pt;
		}

		/*.cproTitleAuthors {
    width: 75%;
    display: block;
}*/

		.cproTitleLine {
			line-height: 1.2;
			display: block;
			width: 100%;
			overflow: visible;
		}

		.cproTitle {
			font-size: 1.5em;
			font-weight: bold;
			display: inline-block;
			white-space: normal;
			width: 75%;
		}

		.cproSubTitle {
			font-size: .7em;
			/*font-weight: bold;*/
			display: inline-block;
			white-space: normal;
			width: 85%;
		}

		.cproAuthorLine {
			font-size: .7em;
			display: block;
			width: 100%;
			overflow: visible;
		}

		.cproAuthors {
			white-space: normal;
			width: 73%;
			display: inline-block;
			/* Add padding inside the span */
			-webkit-box-sizing: border-box;
			/* Safari/Chrome, other WebKit */
			-moz-box-sizing: border-box;
			/* Firefox, other Gecko */
			box-sizing: border-box;
			/* Opera/IE 8+ */
			padding-right: 15px;
		}

		.cproAuthor2Line {
			font-size: .7em;
			display: block;
			/*font-style: italic;*/
		}

		.cproKeyTempoTimeLine {
			font-size: .8em;
			font-weight: bold;
			/*margin-top: .4em;*/
		}

		.cproSongKeyWrapper {
			white-space: nowrap;
		}

		.cproSongKey {
			font-family: Verdana, Arial, Helvetica, sans-serif;
			font-weight: bold;
			color: #000000;
			background-color: transparent;
			border: none;
		}

		.cproSongKeyChangeWrapper {
			font-family: Verdana, Arial, Helvetica, sans-serif;
			font-weight: bold;
			color: #000000;
			background-color: transparent;
			border: none;
			float: right;
		}

		.cproTempoTimeWrapper {
			white-space: nowrap;
		}

		.cproSecondPageTitleLine {
			display: block;
			line-height: 1.2;
			overflow: visible;
			font-size: 1.4rem;
			font-weight: bold;
			white-space: normal;
			padding-bottom: 20pt;
		}

		.cproPageNumber {
			float: right;
			font-size: .6em;
			font-weight: normal;
		}

		.cproSongBody {
			background-color: #ffffff;
			border: none;
			/*font-size: 1.1em;*/
			font-family: Verdana, Arial, Helvetica, sans-serif;
			overflow: visible;
		}

		.cproComment {
			/*font-style: italic;*/
			/*font-size: 1.2em;*/
			display: inline-block;
			font-weight: bold;
			line-height: 2;
			text-transform: uppercase;
		}

		.cproColumn {
			float: left;
			width: 50%;
			font-size: .9em;
			white-space: -moz-pre-wrap;
			white-space: pre-wrap;
			-moz-box-sizing: border-box;
			box-sizing: border-box;
			max-width: 440px;
		}

		.cproColumn span.cproComment {
			font-size: 1.1em;
			margin-top: .5em;
		}

		.cproColumn.leftColumn {
			padding-right: 10px;
		}

		.cproColumn.rightColumn {
			padding-left: 10px;
		}

		.cproColumn .cproSongSection .cproSongLine {
			padding-left: 0;
		}

		/* Clear floats after the columns */
		.cproSongBody:after {
			content: "";
			display: table;
			clear: both;
		}

		/* important stops unintended page break for print */
		div#ChordSheetViewerContainer pre {
			-moz-page-break-inside: auto;
			page-break-inside: auto;
		}

		.cproPageBreak {
			margin: 10px 0 0 0;
			padding: 10px 0;
			border-top: 1px dotted #c5c5c5;
		}

		.cproSongSection {
			display: block;
			-moz-page-break-inside: avoid;
			page-break-inside: avoid;
		}

		.cproSongLine {
			padding-left: 2em;
			display: inline-block;
			line-height: 1.1em;
			padding-top: .2em;
		}

		.lyricsOnly {
			line-height: 1;
		}

		.chordWrapper {
			display: inline-block;
			position: relative;
			vertical-align: bottom;
		}

		.cproSongLine .chordWrapper .chord {
			font-family: Verdana, Arial, Helvetica, sans-serif;
			color: #000000;
			background-color: transparent;
			border: none;
			position: relative;
			font-weight: bold;
			white-space: nowrap;
			padding: 0 .4em 0 0;
			float: left;
		}

		.chordsOnly .chordWrapper .chord {
			padding: 0;
			float: none;
		}

		.chordsOnly .chordWrapper .chordLyrics {
			float: none;
		}

		.chordsOnly .cproDirectionWrapper .cproDirection {
			float: none;
		}

		.chordLyrics {
			float: left;
			clear: both;
		}

		.cproDirectionWrapper {
			display: inline-block;
			position: relative;
			vertical-align: bottom;
		}

		.cproDirection {
			color: #000000;
			background-color: transparent;
			border: none;
			position: relative;
			font-weight: normal;
			font-style: italic;
			white-space: nowrap;
			padding: 0;
			float: left;
		}

		h1 {
			font-size: 2em;
			font-weight: bold;
		}

		pre {
			margin: 0 0 0;
		}


		/* ChordPro Footer
  ------------------------------ */
		.copyright-info {
			font-family: Verdana, Arial, Helvetica, sans-serif;
			font-size: .7em;
			text-align: center;
			margin: 0;
			margin-bottom: 0;
			padding: 2em 0 0 0;
		}

		.copyright-info p,
		ul {
			margin: 0;
			line-height: 1.3;
			padding: 0;
		}

		.songnumber {
			font-weight: bold;
		}

		.copyright {
			line-height: 1.3;
			list-style-type: none;
		}

		ul.copyright li {
			list-style-type: none;
			display: inline;
		}

		ul.copyright li:before {
			content: " | ";
		}

		ul.copyright li:first-child:before {
			content: none;
		}

		.disclaimer {}

		.licenseno {}


		/* ChordPro Div Classes
  ------------------------------ */
		#ChordSheetViewerContainer {
			position: relative;
			overflow: hidden;
			padding-bottom: 90%;
			margin-bottom: 1.5em;
			border: 1px solid #e6e6e6;
			padding: 1.5rem 1rem 1rem 2rem;
			max-width: 900px;
		}

		#ChordSheetViewerContainer iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}

		@media print {
			#ChordSheetViewerContainer {
				border: none;
			}

			a[href]:after {
				content: none !important;
			}

			a {
				text-decoration: none;
				pointer-events: none;
				cursor: default;
				color: #000000;
			}

			/* Override all font size, margin, and padding with pt units for print */

			.cproTitle {
				font-size: 16pt !important;
			}

			.cproAuthorLine {
				font-size: 7pt !important;
				margin-top: 2pt;
			}

			.cproAuthors {
				padding-right: 11.25pt !important;
			}

			.cproAuthor2Line {
				font-size: 7pt !important;
				margin-top: 2pt;
			}

			.cproKeyTempoTimeLine {
				font-size: 9pt !important;
				margin-top: 2pt;
			}

			.cproSecondPageTitleLine {
				font-size: 14pt !important;
				padding-bottom: 20pt;
			}

			.cproPageNumber {
				font-size: 11pt !important;
			}

			.cproSongBody {
				font-size: 13pt !important;
			}

			.cproColumn {
				font-size: 10pt !important;
				letter-spacing: -1pt;
				max-width: 276pt;
			}

			.cproColumn span.cproComment {
				font-size: 11pt !important;
				margin-top: 11pt;
			}

			.cproColumn.leftColumn {
				padding-right: 11pt;
			}

			.cproColumn.rightColumn {
				padding-left: 11pt;
			}


			.cproColumn .cproSongSection .cproSongLine {
				padding-left: 0 !important;
			}

			.cproColumn .cproSongSection .cproSongLine code.chord {
				font-size: 10pt !important;
			}

			.cproSongLine {
				padding-left: 24pt !important;
				line-height: 13pt;
				padding-top: 1pt;
			}

			h1 {
				font-size: 24pt !important;
			}

			.copyright-info {
				font-size: 8pt !important;
				padding: 18pt 0 0 0 !important;
			}

			body {
				padding: 0 0 0 0 !important;
			}

			#ChordSheetViewerContainer {
				padding: 16pt 30pt 12pt 24pt !important;
			}

			.cproPageBreak {
				page-break-before: always;
				break-before: page;
				padding: 0;
				margin: 0;
				border: none;
			}
		}

		@page {
			size: auto;
			margin: 10mm 0 10mm 5mm;
		}

		/* Overwrite footer copyright class in songselect*/
		#ChordSheetViewerContainer>div>ul.copyright {
			font-size: inherit;
		}

		#ChordSheetViewerContainer a {
			font-size: inherit;
		}

		.placeholder,
		.placeholder-chord {
			display: inline-block;
			min-height: 1em;
			height: 1.25em;
			vertical-align: middle;
			background-color: hsl(200, 10%, 20%);
			opacity: 0.3;
			max-width: 100%;
		}

		.placeholder-chord {
			width: 1.5em;
		}
	</style>
	<span class="cproSongHeader">
		<span class="cproTitleLine">
			<span class="cproTitle"><span class="placeholder" style="width:200px;"></span>
		</span>

		<span class="cproAuthorLine" style="margin-top: 0.5em;">
			<span class="cproAuthors"><span class="placeholder" style="width:300px;"></span>
		</span>
		<div class="cproKeyTempoTimeLine" style="margin-top: 0.5em;">
			<span class="cproSongKeyWrapper"> <code class="cproSongKey" data-chordname="E"><span class="placeholder-chord"></span></code> </span>
			<span class="cproTempoTimeWrapper"> <span class="placeholder-chord"></span>  <span class="placeholder-chord"></span></span>
		</div>
	</span>
	<br>
	<div>
    <div style="margin-bottom:0.5em;"><span class="placeholder" style="width:100px; font-size:1.5em;"></span></div>
    <div>
      <div><span class="placeholder-chord"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 340px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:75px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 450px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:25px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 201px"></span></div>

      <div><span class="placeholder-chord"style="margin-left:66px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 320px"></span></div>
    </div>
  </div>
  <div style="margin-top:2em;">
    <div style="margin-bottom:0.5em;"><span class="placeholder" style="width:100px; font-size:1.5em;"></span></div>
    <div>
      <div><span class="placeholder-chord"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 340px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:75px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 450px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:25px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 201px"></span></div>

      <div><span class="placeholder-chord"style="margin-left:66px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 320px"></span></div>
    </div>
  </div>
  <div style="margin-top:2em;">
    <div style="margin-bottom:0.5em;"><span class="placeholder" style="width:100px; font-size:1.5em;"></span></div>
    <div>
      <div><span class="placeholder-chord"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 340px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:75px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 450px"></span></div>

      <div><span class="placeholder-chord" style="margin-left:25px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 201px"></span></div>

      <div><span class="placeholder-chord"style="margin-left:66px"></span> <span class="placeholder-chord" style="margin-left:40px"></span> <span class="placeholder-chord" style="margin-left:160px"></span></div>
      <div><span class="placeholder" style="width: 320px"></span></div>
    </div>
  </div>

	<div class="copyright-info">
		<p class="songnumber"><span class="placeholder" style="width:100px"></span></p>
		<ul class="copyright">
			<li><span class="placeholder" style="width:350px"></span></li>
		</ul>
		<p class="disclaimer"><span class="placeholder" style="width:500px"></span></p>
		<p class="licenseno"><span class="placeholder" style="width:350px"></span></p>
	</div>
</div>`);

function mountShadowDOM() {
  if (!container.value) {
    return;
  }
  shadowDOM = container.value.attachShadow({ mode: "open" });
  shadowDOM.appendChild(contentsElement);
  updateShadowDOM();
}

function updateShadowDOM() {
  contentsElement.innerHTML = html.value;
}
</script>

<template>
  <div
    id="ChordSheetViewerContainer"
    ref="container"
    class="sheet-music-chords"
  />
</template>

<style scoped lang="postcss">
.sheet-music-chords {
  @apply border rounded shadow-lg p-10;
}
#ChordSheetViewerContainer {
  font-size: 0.95rem !important;
  opacity: 0.5;
}

@media screen(max-md) {
  #ChordSheetViewerContainer {
    font-size: 0.6rem !important;
  }
}

@media screen(max-sm) {
  #ChordSheetViewerContainer {
    font-size: 0.4rem !important;
  }
}
</style>
